import { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { api, fmtDate } from "../../lib/api";

export const SESSION_C = { new: "var(--amber)", in_progress: "var(--cyan)", scheduled: "var(--numerique-text)", done: "#6FCF97", cancelled: "var(--text-2)" };

export const SessionStatusPill = ({ status }) => {
  const { t } = useLang();
  return <span className="pill" style={{ "--c": SESSION_C[status], "--ct": SESSION_C[status] }}>{t.academy.statuses[status]}</span>;
};

export const ClientAcademyRequests = () => {
  const { t, lang } = useLang();
  const a = t.academy;
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/me/academy-requests").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (rows === null) return null;
  return (
    <div className="panel pro-panel" data-testid="client-academy-requests">
      <div className="sub-head" style={{ marginBottom: 12 }}>
        <h3 className="sub-title">{a.mine}</h3>
        <a href="/#academie" className="btn btn-ghost btn-sm" data-testid="client-academy-catalog-link"><GraduationCap aria-hidden="true" />{a.catalogLink}</a>
      </div>
      {!rows.length ? <p className="empty" data-testid="client-academy-empty">{a.mineEmpty}</p> : (
        <div className="table-wrap"><table className="data-table" data-testid="client-academy-table">
          <thead><tr>{["ref", "date", "module", "participants", "dates", "format", "status"].map((k) => <th key={k}>{a.h[k]}</th>)}</tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} data-testid={`client-academy-row-${r.ref}`}>
              <td className="mono strong">{r.ref}</td>
              <td className="mono">{fmtDate(r.created_at, lang)}</td>
              <td>{lang === "en" ? r.module_title_en : r.module_title_fr}</td>
              <td className="mono">{r.participants}</td>
              <td>{r.preferred_dates}</td>
              <td>{a.formats[r.format]}</td>
              <td><SessionStatusPill status={r.status} /></td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </div>
  );
};
